import styled from "styled-components";

export const StyledDashboard = styled.div`
    display: flex;
    width: 100%;
    min-width: 1350px;
`;

export const StyledMain = styled.main`
    position: relative;
    flex-grow: 1;
    flex-shrink: 1;
`;